import { createFileRoute } from "@tanstack/react-router";
import DaciaHub from "@/pages/hub/DaciaHub";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/de/dacia-gebraucht/")({
  head: () => routeHead("/de/dacia-gebraucht/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <DaciaHub />
  );
}
